import cx from "classnames";
import Button from "modules/Core/sub-modules/ui-kit/components/Button";
import strappedConnected from "modules/Core/higher-order-components/strappedConnected";
import withShouldRender from "modules/Core/higher-order-components/withShouldRender";
import cells from "modules/cycles/state";
import { useCallback } from "react";
import styles from "./styles.module.scss";

export default strappedConnected(
    withShouldRender(Button),
    {},
    {
        onClick: (activityId, key, cycleId, callback) => cells.stampActivity.action({
            key,
            id: activityId,
            cycleId,
            callback
        })
    },
    ({ activityId, stampKey, cycleId, callback, onClick, className }) => ({
        onClick: useCallback(() => onClick(activityId, stampKey, cycleId, callback), [onClick, activityId, stampKey, cycleId, callback]),
        className: cx(styles.container, className)
    })
)
